import { useEffect, useRef } from "react"

const DEFAULT_OPTIONS = {
  speed: 0.07,
  maxOffset: 30,
}

export function useForegroundParallax(ref, options = {}) {
  // Need to store the latest parameters in a stable ref
  const paramsRef = useRef({ ...DEFAULT_OPTIONS })

  // Keep the latest values updated every render so that effect does not re-run
  paramsRef.current.speed = options.speed ?? DEFAULT_OPTIONS.speed
  paramsRef.current.maxOffset = options.maxOffset ?? DEFAULT_OPTIONS.maxOffset

  useEffect(() => {
    const el = ref.current
    if (!el) return

    let animationId = null
    let isMounted = true

    const handleScroll = () => {
      if (animationId === null) {
        animationId = requestAnimationFrame(() => {
          if (!isMounted) return // Prevent run if unmounted

          const { speed, maxOffset } = paramsRef.current
          const scrollY = window.scrollY
          el.style.transform = `translateY(${Math.min(
            scrollY * speed,
            maxOffset,
          )}px)`

          animationId = null
        })
      }
    }

    window.addEventListener("scroll", handleScroll, { passive: true })

    return () => {
      isMounted = false
      window.removeEventListener("scroll", handleScroll)

      if (animationId !== null) {
        cancelAnimationFrame(animationId)
      }
    }
  }, [ref]) // With this, the effect runs only once
}
